export default __webpack_public_path__ + "static/coin_grey-055fe163a8aace59a7b2c1b840fac321.png";